import React from 'react';
import axios from 'axios';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

import SendFeedback from './SendFeedback';
import Profile from './Profile';
import ChangeProfileDataModal from './ChangeProfileData';
import SettingsModal from './Settings';

import styles from '../styles/Header.module.css';

import Logo from './Logo';

const Header = () => {
    const [isProfileModal, setIsProfileModal] = React.useState(false);
    const [isChangeProfileDataModal, setIsChangeProfileDataModal] = React.useState(false);
    const [isSettingsModal, setIsSettingsModal] = React.useState(false);
    const [isSendFeedbackModal, setIsSendFeedbackModal] = React.useState(false);

    const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);

    const location = useLocation();


    const [fiodata, setFiodata] = React.useState([]);
    const [loading, setLoading] = React.useState(true);

    const handleLogout = () => {
        localStorage.removeItem('token');
        window.location.href = '/';
    };

    React.useEffect(() => {
        const token = localStorage.getItem('token');

        if (token) {
            axios.get('/api/get-fio', {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then((response) => {
                setFiodata(response.data[0]);
                setLoading(false);
            }).catch(err => {
                // setLoading(false);
            });
        } else {
            handleLogout();
        }
    }, []);

    React.useEffect(() => {
        setIsMobileMenuOpen(false);
    }, [location]);

    const getActiveClassName = (path) => {
        return location.pathname === path ? `${styles.navButton} ${styles.active}` : styles.navButton;
    };

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    return (
        <>
            {isProfileModal && <Profile closeModal={() => setIsProfileModal(false)} openChangeProfileDataModal={() => {setIsProfileModal(false); setIsChangeProfileDataModal(true)}} />}
            {isChangeProfileDataModal && <ChangeProfileDataModal closeModal={() => setIsChangeProfileDataModal(false)} openProfileModal={() => {setIsProfileModal(true); setIsChangeProfileDataModal(false)}}/>}
            {isSendFeedbackModal && <SendFeedback closeModal={() => setIsSendFeedbackModal(false)} />}
            {isSettingsModal && <SettingsModal closeModal={() => setIsSettingsModal(false)}/>}

            <div className={styles.header}>
                <div className={styles.headerMenu}>
                    <Logo to='/home' position='relative' />
                </div>
                <div className={styles.headerMenu}>
                    <ul>
                        <li><a className={styles.navButton} onClick={() => {setIsSettingsModal(true)}}><img src='/img/icons/navigationIcons/setting.svg' alt='-' />Настройки</a></li>
                        <li><a className={styles.navButton} onClick={() => {setIsSendFeedbackModal(true)}}>Обратиться в поддержку</a></li>
                        <li><a className={styles.navButton} style={{wordBreak: 'break-word'}} onClick={() => {setIsProfileModal(true)}}>{loading ? <>Загрузка...</> : <>{fiodata.lastname} {fiodata.firstname} {fiodata.surname}</>}</a></li>
                    </ul>
                </div>
            </div>

            <div className={styles.headerMobile}>
                <div className={styles.headerMobileLine}>
                    <Logo to='/home' position='relative' />
                    {isMobileMenuOpen ? 
                    (
                        <svg onClick={toggleMobileMenu} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="x-close"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#000000"/></svg>
                    )
                    :
                    (
                        <svg onClick={toggleMobileMenu} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="menu"><path fill="#000000" d="M3,8H21a1,1,0,0,0,0-2H3A1,1,0,0,0,3,8Zm18,8H3a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Zm0-5H3a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Z"></path></svg>
                    )
                    }
                </div>
                {isMobileMenuOpen ? 
                (
                    <div className={styles.headerMobileLine}>
                        <motion.div
                            initial={{ y: '-10%', opacity: 0 }}
                            animate={{ y: '0%', opacity: 1 }}
                            exit={{ y: '-10%', opacity: 0 }}
                            transition={{ duration: 0.3 }}
                            layout
                        >
                            <ul>
                                <li><Link to='/home' className={getActiveClassName('/home')}>Главная</Link></li>
                                <li><a className={styles.navButton} onClick={() => {setIsSettingsModal(true); toggleMobileMenu()}}>Настройки</a></li>
                                <li><a className={styles.navButton} onClick={() => {setIsSendFeedbackModal(true); toggleMobileMenu()}}>Обратиться в поддержку</a></li>
                                <li><a className={styles.navButton} onClick={() => {setIsProfileModal(true); toggleMobileMenu()}}>Профиль</a></li>
                            </ul>
                        </motion.div>
                    </div>
                ) 
                : 
                (
                    <></>
                )}
            </div>
        </>
    )
}

export default Header;